import areSupportedElements from './areSupportedElements';
import convertSyntax from './convertSyntax';
import extractAccessKeyCandidates from './extractAccessKeyCandidates';
import flattenPatternElements from './flattenPatternElements';
import flattenMessage from './flattenMessage';
import getEmptyMessage from './getEmptyMessage';
import getReconstructedMessage from './getReconstructedMessage';
import getSimplePreview from './getSimplePreview';
import getSyntaxType from './getSyntaxType';
import isPluralExpression from './isPluralExpression';
import isSimpleElement from './isSimpleElement';
import isSimpleMessage from './isSimpleMessage';
import isSimpleSingleAttributeMessage from './isSimpleSingleAttributeMessage';
import isSupportedMessage from './isSupportedMessage';
import parser from './parser';
import serialize from './serialize';
import serializer from './serializer';

export default {
    areSupportedElements,
    convertSyntax,
    extractAccessKeyCandidates,
    flattenPatternElements,
    flattenMessage,
    getEmptyMessage,
    getReconstructedMessage,
    getSimplePreview,
    getSyntaxType,
    isPluralExpression,
    isSimpleElement,
    isSimpleMessage,
    isSimpleSingleAttributeMessage,
    isSupportedMessage,
    parser,
    serialize,
    serializer,
};
